export const moneyCatalogDetailsFilters = ({ selectOptionsYear }) => {
  return [
    {
      control: "autocomplete",
      label: "Έτος",
      name: "year",
      options: selectOptionsYear.map((option) => ({
        key: option.value,
        value: option.value,
      })),
    },
    {
      control: "autocomplete",
      label: "Κατάσταση",
      name: "status",
      options: [
        { key: "Εκκρεμεί", value: "0" },
        { key: "Επαληθευμένο", value: "1" },
        { key: "Μη Επαληθευμένο", value: "2" },
      ],
    },
  ];
};
